// Libraries
import { isEqual } from "lodash";

// Types
import { DEAL_TYPE_MAP, DEFAULT_INCLUDED_STATES_BY_TABS, TAB_NAMES } from "@/DataPages/constants/sales-operations";
import { TDealTypeKey, TIncludedAction, TIncludedState } from "@/DataPages/types/salesOperations/salesLog/utils";

function handleSetInclude(state: TIncludedState, action: TIncludedAction) {
	const { type, payload } = action;

	if (type === "*") {
		return payload;
	}

	const currentValue = state?.[type];

	if (!currentValue) {
		return state;
	}

	return { ...state, [type]: payload };
}

function getInitialState() {
	return Object.entries(DEAL_TYPE_MAP).reduce((acc, [key, name]) => {
		acc[key as TDealTypeKey] = { disabled: false, included: false, name: name };
		return acc;
	}, {} as TIncludedState);
}

function getInitialStateByTab(paramTab: (typeof TAB_NAMES)[keyof typeof TAB_NAMES]) {
	const { disabled, unchecked } = DEFAULT_INCLUDED_STATES_BY_TABS[paramTab] ?? DEFAULT_INCLUDED_STATES_BY_TABS["default"];

	const state: TIncludedState = {} as TIncludedState;

	for (const [capitalLetter, name] of Object.entries(DEAL_TYPE_MAP)) {
		const disabledValue = disabled.includes(capitalLetter as TDealTypeKey);
		const includedValue = !unchecked.includes(capitalLetter as TDealTypeKey);
		state[capitalLetter as TDealTypeKey] = { disabled: disabledValue, included: includedValue, name };
	}

	return state;
}

function includedCheckboxChanged(currentState: TIncludedState, tabSelected: string): boolean {
	const defaultState = getInitialStateByTab(tabSelected as (typeof TAB_NAMES)[keyof typeof TAB_NAMES]);

	return !isEqual(defaultState, currentState);
}

export { handleSetInclude, getInitialState, getInitialStateByTab, includedCheckboxChanged };
